<template>
    <div :style="[elementStyles, basicContentStyles]">
    </div>
</template>

<script>
    export default {
        props: ['data', 'basicContentStyles'],
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    backgroundImage: 'url("' + (this.data.background_image??"") + '")',
                    backgroundSize: '100% 100%',
                    opacity: opacity,
                }
            },
            styles: function () {
                let transform = 'translate(' + this.data.position.left + 'px,' + this.data.position.top + 'px)';
                let width = Math.max(this.hasMinWidth(), this.data.size.width);
                let height = Math.max(this.hasMinHeight(), this.data.size.height);
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency / 100;
                }

                return {
                    webkitTransform: transform,
                    transform: transform,
                    zIndex: this.data.position.zindex,
                    width: width + 'px',
                    height: height + 'px',
                    backgroundImage: 'url("' + (this.data.background_image??"") + '")',
                    opacity: opacity,
                }
            }
        }
    }
</script>
